// extracted by mini-css-extract-plugin
export default {"body-rows":"KFw4c2lSVXRBa0GbRoVX"};